// Locale-independent slugs for the 21 canon stations, in descent order.
// The order mirrors canonContent layers/stations exactly, and the how-we-work
// practice lists follow the same order, so a (layerId, index) pair addresses
// one station in every language. /insights#<slug> deep-links into the descent.

export const CANON_SLUGS = {
  strategy: ['purpose', 'principles', 'develop-people', 'vision', 'breakthrough', 'deploy-strategy'],
  management: ['breakdown', 'value-stream', 'flow', 'economics', 'capacity', 'visual', 'reviews', 'vault'],
  engineering: ['architecture', 'code-to-value', 'clean-code', 'test-first', 'automate', 'direct-agents', 'monitor'],
}

export const stationHref = (layerId, index) => {
  const slug = (CANON_SLUGS[layerId] || [])[index]
  return slug ? `/insights#${slug}` : '/insights'
}
